import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = '/kyc';

export default {
processKycVendorCallback(vendor, payload) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/vendor/${vendor}/callback`, payload);
  }
}